module.exports = __webpack_public_path__ + "static/media/JGN-BNB.a7d0ad91.png";